import React from 'react';
import HeaderAllInOne from './HeaderAllInOne';
import HeaderTraditional from './HeaderTraditional';
import '../../../src/assets/scss/common/_header.scss';
const HeaderComponent = (props) => {
  return (<>
    <div className="app-container">
      <header className="header">
        <div className={`header-main ${props.editorType ? props.editorType+'-main' : 'traditional-main'}`}>
          {props.editorType == 'allinone' ? <HeaderAllInOne saveResume={props.saveResume}  /> : <HeaderTraditional saveResume={props.saveResume}  />}
        </div>
      </header>
    </div>
    {!props.hasOwnProperty('showSplash') ? <Splash /> : ''}
  </>);
}
export default HeaderComponent;